<ng-template injectComp></ng-template>
